module.exports = __webpack_public_path__ + "img/male_8.5d9d7cc0.png";